const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'DESERIALIZER_INDEXING': {
      const { payload } = action
      const { payloadIndices } = payload

      if (payload.view !== 'personalPanel' || payload.viewKey === undefined) {
        return state
      }
      return {
        ...state,
        [payload.viewKey]: {
          ...state[payload.viewKey],
          [payloadIndices.type]: payloadIndices.ids,
        },
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
